import { render } from "./ItemSwiperComponent.vue?vue&type=template&id=431cfe67&scoped=true"
import script from "./ItemSwiperComponent.vue?vue&type=script&lang=js"
export * from "./ItemSwiperComponent.vue?vue&type=script&lang=js"

import "./ItemSwiperComponent.vue?vue&type=style&index=0&id=431cfe67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-431cfe67"]])

export default __exports__